import { useCallback } from 'react';
import { axiosService, useUser } from 'shared/helpers/axios';

const useFollowActions = () => {
  const { isAuthenticated } = useUser();

  const followEntity = useCallback(
    async (contentType, objectId) => {
      if (!isAuthenticated) return null;
      const normalizedType = contentType?.toString().toLowerCase();
      const res = await axiosService.post('/interact/follows/', {
        content_type: normalizedType,
        object_id: objectId,
      });
      return res.data;
    },
    [isAuthenticated]
  );

  const unfollowEntity = useCallback(
    async (contentType, objectId) => {
      if (!isAuthenticated) return null;
      const normalizedType = contentType?.toString().toLowerCase();
      const res = await axiosService.delete(
        `/interact/follows/unfollow/?content_type=${encodeURIComponent(normalizedType)}&object_id=${encodeURIComponent(objectId)}`
      );
      return res.data;
    },
    [isAuthenticated]
  );

  return {
    followEntity,
    unfollowEntity,
  };
};

export default useFollowActions;
